import { styled } from "@mui/material";

export const StyledContainer = styled("svg")(() => ({
  width: "220px",
  aspectRatio: "220/28",
  cursor: "pointer",
}));
